<template>
  <div class="relative w-$portalContainerWidth mx-auto mt-20px">
    <NavigationBarProps></NavigationBarProps>
    <el-row :gutter="10" class="h-650px mt-10px">
      <el-col :span="16">
        <div class="flex justify-between items-center">
          <span class="font-bold">筛选:</span>
          <span
            :class="[active === '全部' ? 'text-hex-c11920' : '', 'cursor-pointer']"
            @click="active = '全部'"
            >全部</span
          >
          <span
            :class="[active === '未读' ? 'text-hex-c11920' : '', 'cursor-pointer']"
            @click="active = '未读'"
            >未读</span
          >
          <span
            :class="[active === '已读' ? 'text-hex-c11920' : '', 'cursor-pointer']"
            @click="active = '已读'"
            >已读</span
          >
          <span class="font-bold">排序:</span>
          <span class="text-hex-c11920 cursor-pointer" @click="dataSort"
            >按日期 <i class="el-icon-sort"></i
          ></span>
          <span class="font-bold">时间：</span>
          <span>
            <el-date-picker
              size="small"
              class="max-w-330px"
              v-model="timeRange"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              @change="getList"
            >
            </el-date-picker>
          </span>
          <span class="cursor-pointer" @click="reset">重置</span>
        </div>
        <div class="mt-10px text-hex-999999 text-14px">相关结果: {{ page.total }}个</div>
        <!-- <div class="my-10px" v-for="item in dataList" :key="item.id">
            <div class="flex justify-between items-center py-15px">
              <div class="flex items-center">
                <div class="w-6px h-6px rounded-3px border-hex-ec4c4c border-3 mx-10px"></div>
                <div class="font-bold text-16px">{{ item.title }}</div>
              </div>
              <div class="text-14px text-hex-c4c8cb">{{ item.sendTime }}</div>
            </div>
            <div
              class="pl-26px py-10px text-13px text-hex-c4c8cb tracking-1px leading-18px"
              style="line-height: 18px"
            >
              李泽证件到期提
            </div>
          </div> -->
        <div class="h-[calc(100%-60px)] overflow-y-auto">
          <div
            :class="[
              'my-10px',
              index + 1 !== dataList.length ? 'border-b' : '',
              'border-hex-e6e6e6',
              'h-60px',
            ]"
            v-for="(item, index) in dataList"
            :key="item.id"
          >
            <div class="flex justify-between items-center pt-10px">
              <div class="flex items-center w-85/100">
                <div class="font-bold text-16px truncate h-20px">{{ item.title }}</div>
              </div>
              <div class="text-14px text-hex-c4c8cb">
                {{ dayjs(item.sendTime).format('YYYY/MM/DD') }}
              </div>
            </div>
            <div
              class="text-13px text-hex-c4c8cb tracking-1px leading-18px truncate"
              style="line-height: 18px"
            >
              {{ item.content }}
            </div>
          </div>
        </div>
      </el-col>
      <!-- <el-col :span="14">
        <el-card class="h-full w-full mr-10px" :body-style="{ height: '100%' }"> </el-card>
      </el-col> -->
    </el-row>

    <div class="flex justify-center mt-20px">
      <el-pagination
        background
        @size-change="searchList"
        @current-change="getList"
        :current-page.sync="page.pageNo"
        layout="total, sizes, prev, pager, next, jumper"
        :page-size.sync="page.pageSize"
        :total="page.total"
        :page-sizes="[1, 15, 30, 45, 60, 75, 90]"
        :pager-count="5"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { MessageReceiveApi } from '@wiz-api/message-management'
import { AbpApplicationConfigurationApi } from '@wiz-api/abp-application'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import NavigationBarProps from '../components/NavigationBarProps'

const messageReceiveApi = new MessageReceiveApi()
const dataCategoryApi = new DataCategoryApi()

const abpApplicationConfigurationApi = new AbpApplicationConfigurationApi()

export default {
  name: 'Message',
  components: {
    NavigationBarProps,
  },
  data() {
    return {
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      active: '全部',
      dataList: [],
      searchData: {
        readStatus: '',
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      timeRange: '',
      sort: true,
      sortArr: ['asc', ''],
    }
  },
  created() {
    const { config } = Wiz.globalSettings.dynamicModules.modules['portal-homepage-nanhai']
    document.title = `消息 - ${config.title}`
    this.getList()
    this.getConfig()
  },
  watch: {
    active() {
      this.getList()
    },
  },
  methods: {
    reset() {
      this.page = this.$options.data().page
      this.timeRange = this.$options.data().timeRange
      this.active = this.$options.data().active
    },
    // 获取数据字典
    async getConfig() {
      let ids = []
      const [configError, abpConfigList] = await abpApplicationConfigurationApi.get()
      if (!configError) {
        const [statusError, statusRes] = await dataCategoryApi.getListByCodes({
          codes: [abpConfigList.setting.values['MessageManagement.DataCategory.MessageReadStatus']],
          includeDetails: true,
        })
        if (!statusError) {
          ids = statusRes.map((item) => {
            return item.id
          })
          this.getItemsByIds(ids)
        }
      }
    },
    // 获取数据字典列表
    async getItemsByIds(ids) {
      const [err, res] = await dataCategoryApi.getListByIds({
        ids,
        includeDetails: true,
      })
      if (!err) {
        // 消息消息读取状态
        const MessageReadStatus = res.filter((item) => {
          return item.code === 'MessageReadStatus'
        })[0].dataItems
        this.messageReadList = MessageReadStatus
      }
    },
    dataSort() {
      this.sort = !this.sort
      this.getList()
    },
    async getList() {
      const readStatus = _.find(this.messageReadList, { displayName: this.active })
      const [err, res] = await messageReceiveApi.pagedListQuery({
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
        maxResultCount: this.page.pageSize,
        readStatus: readStatus ? Number(readStatus?.code) : null,
        startTime: this.timeRange ? this.timeRange[0] : null,
        endTime: this.timeRange ? this.timeRange[1] : null,
        sorting: this.sort ? this.sortArr[0] : this.sortArr[1],
      })
      if (!err && res) {
        this.dataList = res.items
        this.page.total = res.totalCount
      }
    },
    searchList() {
      this.page.pageNo = 1
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.selectBorder {
  ::v-deep .el-input__inner {
    border: none;
  }
  input::placeholder {
    color: red;
  }
}
.test {
  ::v-deep .el-radio-button__inner {
    background: none;
    border: none;
    color: red;
  }
}
</style>
